import { Language, LocalizedString } from '@shared/types'

export const FALLBACK_EXIT_URL_SMOBILE: LocalizedString = {
  [Language.Fi]: 'digila://s-group.fi?status=failed',
  [Language.Sv]: 'digila://s-group.fi?status=failed',
}

export const FALLBACK_EXIT_URL_WEB: LocalizedString = {
  [Language.Fi]: 'https://www.s-pankki.fi/fi/elamantilanteet/lapsi-ja-nuori-s-pankin-asiakkaana/',
  [Language.Sv]: 'https://www.s-pankki.fi/sv/livssituationer/minderarig-som-s-bankens-kund/',
}
